import apiClient from './client';
import { User, Friendship, FriendshipStatus } from '../types';

export interface FriendshipCreate {
  receiver_id: number;
}

export interface FriendshipUpdate {
  status: FriendshipStatus;
}

export const friendsApi = {
  // Search for users to add as friends
  searchUsers: async (query: string): Promise<User[]> => {
    const response = await apiClient.get<User[]>(`/users/search/${query}`);
    return response.data;
  },

  // Send a friend request
  sendFriendRequest: async (receiverId: number): Promise<Friendship> => {
    const response = await apiClient.post<Friendship>('/friends/request', {
      receiver_id: receiverId,
    });
    return response.data;
  },

  // Respond to a friend request (accept/decline)
  respondToFriendRequest: async (friendshipId: number, status: FriendshipStatus): Promise<Friendship> => {
    const response = await apiClient.put<Friendship>(`/friends/request/${friendshipId}`, {
      status,
    });
    return response.data;
  },

  // Get sent friend requests
  getSentRequests: async (): Promise<Friendship[]> => {
    const response = await apiClient.get<Friendship[]>('/friends/requests/sent');
    return response.data;
  },

  // Get received friend requests
  getReceivedRequests: async (): Promise<Friendship[]> => {
    const response = await apiClient.get<Friendship[]>('/friends/requests/received');
    return response.data;
  },

  // Get friends list
  getFriends: async (): Promise<User[]> => {
    const response = await apiClient.get<{items: User[]}>('/friends/');
    return response.data.items;
  },

  // Remove a friend
  removeFriend: async (userId: number): Promise<void> => {
    await apiClient.delete(`/friends/${userId}`);
  },

  // Get friendship status with a user
  getFriendshipStatus: async (userId: number): Promise<{ status: string }> => {
    const response = await apiClient.get<{ status: string }>(`/friends/status/${userId}`);
    return response.data;
  },
};